
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Pagination extends Vue {
    // props
    @Prop({ default: () => ({}) }) value: any //pager对象
    @Prop({ default: () => [10, 20, 50, 100, 200, 500] }) pageSizes!: number[] //页数列表
    @Prop({ default: 'total, sizes, prev, pager, next, jumper' })
    layout!: string
    // 页码改变
    pageChange(page: number) {
        this.value.page = page
        this.$emit('change', this.value)
    }

    // 页数改变
    sizeChange(size: number) {
		localStorage.setItem('platform:page_size_route:' + this.$route.path, size.toString())
        this.value.size = size
        this.$emit('change', this.value)
    }
	
	created() {
		let size = localStorage.getItem('platform:page_size_route:' + this.$route.path)
		if (size) {
			this.value.size = Number(size)
		}
	}
}
